// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tvp-proview_root .tvp-chatIcon {
  width: 9vh;
  height: 9vh;
  display: flex;
  align-items: center;
  justify-content: center;
  display: none;
}
.tvp-proview_root .tvp-resizeChatScreen {
  display: flex;
  flex-direction: column;
  padding: 0px;
  box-sizing: border-box;
  position: absolute;
  max-width: 368px;
  width: 90vw;
  max-height: calc(100vh - 150px);
  height: 90vh;
  right: 15px;
  bottom: 20px;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  box-shadow: -1px 0px 7px -2px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  z-index: 99999;
}
.tvp-proview_root .tvp-chatScreen {
  display: flex;
  flex-direction: column;
  padding: 0px;
  box-sizing: border-box;
  position: absolute;
  max-width: 90vw;
  max-width: 368px;
  width: 90vw;
  max-height: calc(100vh - 150px);
  height: 728px;
  right: 15px;
  bottom: 20px;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  box-shadow: -1px 0px 7px -2px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  z-index: 99999;
}
.tvp-proview_root .tvp-chatHeader {
  height: 57px;
  font-size: 16px;
  padding: 20px;
  font-weight: 700;
  background-color: #fff;
  position: relative;
  border-radius: 10px 10px 0px 0px;
  display: flex;
  flex-direction: row;
}
.tvp-proview_root .tvp-chatButtonWrapper {
  margin-left: auto;
  width: auto;
  display: flex;
  flex-direction: row;
}
.tvp-proview_root .tvp-miniLoader {
  width: 40px;
  height: 40px;
  margin: auto;
}
.tvp-proview_root .tvp-audio-chat-wrapper {
  display: flex;
  flex-direction: row;
}
.tvp-proview_root .tvp-callBtn {
  box-sizing: border-box;
  width: 26.07px;
  height: 26.07px;
  background: #22c55e;
  border: 1px solid #15803d;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.tvp-proview_root .tvp-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.tvp-proview_root .tvp-requested {
  display: flex;
  flex-direction: row;
  font-size: 10px;
  align-items: center;
}
.tvp-proview_root .tvp-chatStatus1 {
  color: #3b82f6 !important;
}
.tvp-proview_root .tvp-connecting {
  height: 15px;
  margin: 0px 5px;
  color: #fbbf24;
}
.tvp-proview_root .tvp-chatStatus2 {
  color: #16a34a !important;
}
.tvp-proview_root .tvp-chatClse {
  box-sizing: border-box;
  width: 26.07px;
  height: 26.07px;
  background: #ef4444;
  border: 1px solid #991b1b;
  border-radius: 50%;
  display: none;
  justify-content: center;
  align-items: center;
}
.tvp-proview_root .tvp-chatInput {
  box-sizing: border-box;
  height: 39px;
  left: 35px;
  top: 687px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
}
.tvp-proview_root .tvp-chatInputfolder {
  display: flex;
  padding: 28px 20px;
  background-color: #f1f5f9;
  justify-content: space-between;
  margin-top: auto;
}
.tvp-proview_root .tvp-iconHolderDisabled {
  width: 35px;
  cursor: pointer;
  height: 35px;
  background-color: #2dd4bf;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: not-allowed;
}
.tvp-proview_root .tvp-iconHolder {
  width: 35px;
  cursor: pointer;
  height: 35px;
  background-color: #2dd4bf;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tvp-proview_root .tvp-chatContent {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 400;
  background-color: #f1f5f9;
  padding: 20px;
  border-radius: 0px 0px 10px 10px;
  overflow-y: auto;
}
.tvp-proview_root .tvp-msgHolder1 {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
}
.tvp-proview_root .tvp-list1 {
  margin-left: auto;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  border-radius: 8px 0px 8px 8px;
}
.tvp-proview_root .tvp-list2 {
  margin-right: auto;
  color: #fff;
  border: 1px solid #1e40af;
  border-radius: 0px 8px 8px 8px;
}
.tvp-proview_root .tvp-list1,
.tvp-proview_root .tvp-list2 {
  max-width: 90%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: initial;
  -webkit-hyphens: auto;
          hyphens: auto;
  overflow: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 12px;
  width: auto;
  margin-bottom: 10px;
}
.tvp-proview_root .tvp-msgDesc1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: -3px;
}
.tvp-proview_root .tvp-msgDesc2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: -3px;
}
.tvp-proview_root .tvp-timeStamp {
  margin-left: 10px;
  color: #94a3b8;
  font-weight: 400;
  font-size: 8px;
  line-height: 144.52%;
}
.tvp-proview_root .tvp-msgRole {
  font-weight: 400;
  font-size: 10px;
  line-height: 144.52%;
  margin-top: -2px;
}
.tvp-proview_root .tvp-msgHolder2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-end;
}
.tvp-proview_root .tvp-chatMessage {
  width: 90%;
  word-wrap: break-word;
}
/* .closeChat{
  display: none;
} */

.tvp-proview_root .tvp-closeChat {
  position: relative;
  inline-size: 27px;
  block-size: 27px;
  border: 1.5px solid red;
  border-radius: 50%;
  background: transparent;
  padding: 0;
  color: red;
  font-family: Arial, Helvetica, sans-serif;
  margin-left: 10px;
}

.tvp-proview_root .tvp-chat-style ul,
.tvp-proview_root .tvp-chat-style ol {
  list-style: revert !important;
  padding-left: 1rem;
}

@media only screen and (max-width: 300px) {
  .tvp-proview_root .tvp-chatScreen {
    display: flex;
    flex-direction: column;
    padding: 0px;
    box-sizing: border-box;
    position: absolute;
    width: 90vw;
    max-width: 90vw;
    max-height: calc(100vh - 150px);
    height: 728px;
    right: 15px;
    left: -90vw;
    bottom: 20px;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    box-shadow: -1px 0px 7px -2px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 99999;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iDAAiD;EACjD,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAIhB,yBAAyB;EACzB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AALlB;AAOA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,8BAA8B;AAChC;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAa;UAAb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,+BAA+B;IAC/B,aAAa;IACb,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,iDAAiD;IACjD,mBAAmB;IACnB,cAAc;EAChB;AACF","sourcesContent":[".tvp-proview_root .tvp-chatIcon {\n  width: 9vh;\n  height: 9vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  display: none;\n}\n.tvp-proview_root .tvp-resizeChatScreen {\n  display: flex;\n  flex-direction: column;\n  padding: 0px;\n  box-sizing: border-box;\n  position: absolute;\n  max-width: 368px;\n  width: 90vw;\n  max-height: calc(100vh - 150px);\n  height: 90vh;\n  right: 15px;\n  bottom: 20px;\n  background: #f1f5f9;\n  border: 1px solid #cbd5e1;\n  box-shadow: -1px 0px 7px -2px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  z-index: 99999;\n}\n.tvp-proview_root .tvp-chatScreen {\n  display: flex;\n  flex-direction: column;\n  padding: 0px;\n  box-sizing: border-box;\n  position: absolute;\n  max-width: 90vw;\n  max-width: 368px;\n  width: 90vw;\n  max-height: calc(100vh - 150px);\n  height: 728px;\n  right: 15px;\n  bottom: 20px;\n  background: #f1f5f9;\n  border: 1px solid #cbd5e1;\n  box-shadow: -1px 0px 7px -2px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  z-index: 99999;\n}\n.tvp-proview_root .tvp-chatHeader {\n  height: 57px;\n  font-size: 16px;\n  padding: 20px;\n  font-weight: 700;\n  background-color: #fff;\n  position: relative;\n  border-radius: 10px 10px 0px 0px;\n  display: flex;\n  flex-direction: row;\n}\n.tvp-proview_root .tvp-chatButtonWrapper {\n  margin-left: auto;\n  width: auto;\n  display: flex;\n  flex-direction: row;\n}\n.tvp-proview_root .tvp-miniLoader {\n  width: 40px;\n  height: 40px;\n  margin: auto;\n}\n.tvp-proview_root .tvp-audio-chat-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n.tvp-proview_root .tvp-callBtn {\n  box-sizing: border-box;\n  width: 26.07px;\n  height: 26.07px;\n  background: #22c55e;\n  border: 1px solid #15803d;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.tvp-proview_root .tvp-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.tvp-proview_root .tvp-requested {\n  display: flex;\n  flex-direction: row;\n  font-size: 10px;\n  align-items: center;\n}\n.tvp-proview_root .tvp-chatStatus1 {\n  color: #3b82f6 !important;\n}\n.tvp-proview_root .tvp-connecting {\n  height: 15px;\n  margin: 0px 5px;\n  color: #fbbf24;\n}\n.tvp-proview_root .tvp-chatStatus2 {\n  color: #16a34a !important;\n}\n.tvp-proview_root .tvp-chatClse {\n  box-sizing: border-box;\n  width: 26.07px;\n  height: 26.07px;\n  background: #ef4444;\n  border: 1px solid #991b1b;\n  border-radius: 50%;\n  display: none;\n  justify-content: center;\n  align-items: center;\n}\n.tvp-proview_root .tvp-chatInput {\n  box-sizing: border-box;\n  height: 39px;\n  left: 35px;\n  top: 687px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n}\n.tvp-proview_root .tvp-chatInputfolder {\n  display: flex;\n  padding: 28px 20px;\n  background-color: #f1f5f9;\n  justify-content: space-between;\n  margin-top: auto;\n}\n.tvp-proview_root .tvp-iconHolderDisabled {\n  width: 35px;\n  cursor: pointer;\n  height: 35px;\n  background-color: #2dd4bf;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: not-allowed;\n}\n.tvp-proview_root .tvp-iconHolder {\n  width: 35px;\n  cursor: pointer;\n  height: 35px;\n  background-color: #2dd4bf;\n  border-radius: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.tvp-proview_root .tvp-chatContent {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  font-size: 12px;\n  font-weight: 400;\n  overflow-y: auto;\n}\n.tvp-proview_root .tvp-chatContent {\n  background-color: #f1f5f9;\n  padding: 20px;\n  border-radius: 0px 0px 10px 10px;\n  overflow-y: auto;\n}\n.tvp-proview_root .tvp-msgHolder1 {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: flex-end;\n}\n.tvp-proview_root .tvp-list1 {\n  margin-left: auto;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);\n  border-radius: 8px 0px 8px 8px;\n}\n.tvp-proview_root .tvp-list2 {\n  margin-right: auto;\n  color: #fff;\n  border: 1px solid #1e40af;\n  border-radius: 0px 8px 8px 8px;\n}\n.tvp-proview_root .tvp-list1,\n.tvp-proview_root .tvp-list2 {\n  max-width: 90%;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  white-space: initial;\n  hyphens: auto;\n  overflow: auto;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 9px 12px;\n  width: auto;\n  margin-bottom: 10px;\n}\n.tvp-proview_root .tvp-msgDesc1 {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: -3px;\n}\n.tvp-proview_root .tvp-msgDesc2 {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin-top: -3px;\n}\n.tvp-proview_root .tvp-timeStamp {\n  margin-left: 10px;\n  color: #94a3b8;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 144.52%;\n}\n.tvp-proview_root .tvp-msgRole {\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 144.52%;\n  margin-top: -2px;\n}\n.tvp-proview_root .tvp-msgHolder2 {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: flex-end;\n}\n.tvp-proview_root .tvp-chatMessage {\n  width: 90%;\n  word-wrap: break-word;\n}\n/* .closeChat{\n  display: none;\n} */\n\n.tvp-proview_root .tvp-closeChat {\n  position: relative;\n  inline-size: 27px;\n  block-size: 27px;\n  border: 1.5px solid red;\n  border-radius: 50%;\n  background: transparent;\n  padding: 0;\n  color: red;\n  font-family: Arial, Helvetica, sans-serif;\n  margin-left: 10px;\n}\n\n.tvp-proview_root .tvp-chat-style ul,\n.tvp-proview_root .tvp-chat-style ol {\n  list-style: revert !important;\n  padding-left: 1rem;\n}\n\n@media only screen and (max-width: 300px) {\n  .tvp-proview_root .tvp-chatScreen {\n    display: flex;\n    flex-direction: column;\n    padding: 0px;\n    box-sizing: border-box;\n    position: absolute;\n    width: 90vw;\n    max-width: 90vw;\n    max-height: calc(100vh - 150px);\n    height: 728px;\n    right: 15px;\n    left: -90vw;\n    bottom: 20px;\n    background: #f1f5f9;\n    border: 1px solid #cbd5e1;\n    box-shadow: -1px 0px 7px -2px rgba(0, 0, 0, 0.25);\n    border-radius: 10px;\n    z-index: 99999;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
